import React, { useRef } from "react";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomDateInput from "../CustomDateInput";
import { DEFAULT_DATE_FORMAT } from "@/consts";

interface DateSelectorProps {
  selectedDate: Date;
  setDate: (date: Date) => void;
  hasBorder?: boolean;
  filteredWorkDays: number[];
  excludedDates: Date[];
  showCalendar?: boolean;
}

const DateSelector: React.FC<DateSelectorProps> = ({
  selectedDate,
  setDate,
  hasBorder,
  filteredWorkDays,
  excludedDates,
  showCalendar,
}) => {
  const now = new Date();
  const dateMoment = dayjs(selectedDate);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <DatePicker
      id="datepicker"
      selected={selectedDate}
      minDate={now}
      onChange={(date: Date | null) => {
        if (date) {
          setDate(date);
        }
      }}
      excludeDates={excludedDates}
      customInput={
        <CustomDateInput
          ref={inputRef}
          value={dateMoment.format(DEFAULT_DATE_FORMAT)}
          onClick={() => inputRef.current?.focus()}
          onNext={() => setDate(dateMoment.add(1, "day").toDate())}
          onPrev={() => setDate(dateMoment.subtract(1, "day").toDate())}
          hasBorder={hasBorder}
        />
      }
      filterDate={(date: Date) => !filteredWorkDays.includes(date.getDay())}
      inline={showCalendar}
    />
  );
};

export default DateSelector;
